module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('h1', {
    staticClass: "mb-2 text-lg font-bold"
  }, [_vm._v("\n      Tareas (" + _vm._s(_vm.filteredTasks.length) + ")\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('app-icon', {
    attrs: {
      "name": 'search',
      "classname": 'w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700'
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.slug),
      expression: "filter.slug"
    }],
    staticClass: "input w-full sm:w-64 box px-10 text-gray-700",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por codigo"
    },
    domProps: {
      "value": (_vm.filter.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "slug", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter dropdown absolute inset-y-0 mr-3 right-0 flex items-center"
  }, [_c('app-icon', {
    attrs: {
      "name": 'chevron-down',
      "classname": 'dropdown-toggle w-4 h-4 cursor-pointer text-gray-700'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter__dropdown-box dropdown-box mt-10 absolute top-0 left-0 z-20"
  }, [_c('div', {
    staticClass: "dropdown-box__content box p-5"
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Cuenta")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.account),
      expression: "filter.account"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "account", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Seleccione la cuenta")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _c('option', {
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n                                  " + _vm._s(account.name) + " - " + _vm._s(account.country.prefix) + "\n                                ")])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.state),
      expression: "filter.state"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el estado")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.id
      }
    }, [_vm._v("\n                                    " + _vm._s(state.name) + "\n                                  ")])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('button', {
    staticClass: "button mt-28 text-white bg-theme-1 shadow-md mr-2",
    on: {
      "click": function($event) {
        _vm.filter = _vm.clearFilter()
      }
    }
  }, [_vm._v("Borrar Filtro")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.state),
      expression: "filter.state"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el estado")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.id
      }
    }, [_vm._v("\n                    " + _vm._s(state.name) + "\n                  ")])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('button', {
    staticClass: "button mt-28 text-white bg-theme-1 shadow-md mr-2",
    on: {
      "click": function($event) {
        _vm.filter = _vm.clearFilter()
      }
    }
  }, [_vm._v("\n                    Borrar Filtro\n                  ")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('router-link', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "to": "/admin/traffic/tasks-without-finish"
    }
  }, [_vm._v("Tareas sin finalizar")]), _vm._v(" "), _c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#task",
      "data-toggle": "modal"
    }
  }, [_vm._v("Crear Tarea")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "overflow-auto intro-y"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredTasks), function(task) {
    return _c('tr', {
      staticClass: "intro-x"
    }, [_c('td', [_c('a', {
      staticClass: "font-medium whitespace-no-wrap",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(_vm._f("limit")(task.name)))]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(task.slug) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(task.created_at) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(task.campaign_attribute.name) + " - " + _vm._s(task.team_name) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(task.campaign_attribute.project_name) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(task.campaign_attribute.project_account_name) + " -\n                " + _vm._s(task.campaign_attribute.project_account_country_prefix) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40"
    }, [_c('div', {
      staticClass: "flex items-center justify-center"
    }, [_vm._l((_vm.users), function(user) {
      return [(task.created_by === user.id) ? _c('div', {
        key: ("user-created_by-" + (user.id)),
        staticClass: "w-10 h-10 image-fit zoom-in"
      }, [_c('img', {
        staticClass: "tooltip rounded-full tooltipstered",
        attrs: {
          "alt": task.user_created_name,
          "src": user.avatar ?
            user.avatar :
            "/static/images/profile.png",
          "title": task.user_created_name
        }
      })]) : _vm._e()]
    }), _vm._v(" "), _vm._l((_vm.users), function(user) {
      return [(task.user_id === user.id) ? _c('div', {
        key: ("user-user_id-" + (user.id)),
        staticClass: "w-10 h-10 image-fit zoom-in -ml-5"
      }, [_c('img', {
        staticClass: "tooltip rounded-full tooltipstered",
        attrs: {
          "alt": task.user_name,
          "src": user.avatar ?
            user.avatar :
            "/static/images/profile.png",
          "title": task.user_name
        }
      })]) : _vm._e()]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "flex items-center justify-center"
    }, [_vm._v("\n                " + _vm._s(task.state_name) + " - " + _vm._s(task.hours) + "hs\n              ")])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button button--sm w-24 text-white",
      class: _vm.dateClass(task)
    }, [_vm._v("\n                " + _vm._s(task.date) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "table-report__action w-56"
    }, [_c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('router-link', {
      staticClass: "cursor-pointer flex items-center mr-3",
      attrs: {
        "to": '/admin/traffic/task/' + task.id
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "edit",
        "classname": "w-4 h-4 mr-2"
      }
    })], 1)], 1)])])
  }), 0)])])]) : _c('app-loading'), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "task"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--md"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    staticClass: "form-task",
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createTask.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.name),
      expression: "task.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.task.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12 xxl:col-span-12"
  }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.description),
      expression: "task.description"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.task.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-12"
  }, [_c('label', [_vm._v("Fecha de entrega")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.date),
      expression: "task.date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.task.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-12"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.project_id),
      expression: "task.project_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task, "project_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return _c('option', {
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n                " + _vm._s(project.name) + " - " + _vm._s(project.account.name) + "\n                " + _vm._s(project.account.country.prefix) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.campaign_id),
      expression: "task.campaign_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task, "campaign_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.filteredCampaigns), function(campaign) {
    return _c('option', {
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v("\n                " + _vm._s(campaign.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Equipo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.team_id),
      expression: "task.team_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task, "team_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el equipo")]), _vm._v(" "), _vm._l((_vm.teams), function(team) {
    return _c('option', {
      domProps: {
        "value": team.id
      }
    }, [_vm._v("\n                " + _vm._s(team.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Url Archivo (opcional)")]), _vm._v(" "), _c('MultiSelect', {
    staticClass: "mt-2",
    attrs: {
      "options": _vm.options,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.task.path),
      callback: function($$v) {
        _vm.$set(_vm.task, "path", $$v)
      },
      expression: "task.path"
    }
  })], 1)]), _vm._v(" "), _vm._m(2)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "whitespace-no-wrap"
  }, [_vm._v("NOMBRE")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ESTADO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("FECHA ENTREGA")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Crear Tarea")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("\n            Crear\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c2e3404","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/task/ListTask.vue
// module id = 437
// module chunks = 1